import "./App.css";
import { useEffect, useState, useRef } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logoImage from "./assets/images/logo.png";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import {
  LOGIN_MESSAGE,
  TAB_NAMES,
  UAM_USER_ADMIN_AD_GROUP_DEV,
  UAM_USER_ADMIN_AD_GROUP_PROD,
  UAM_USER_ADMIN_AD_GROUP_QA,
  UAM_USER_DIGITAL_AD_GROUP_DEV,
  UAM_USER_DIGITAL_AD_GROUP_QA,
  UAM_USER_DIGITAL_AD_GROUP_PROD,
  USER_ACCESS_MANAGEMENT_TABS,
  DIGITAL_ACCESS_MANAGEMENT_TABS
} from "./lib/constant";
import { useLocation, useNavigate } from "react-router-dom";
import Routes from "./routes";
import { Drawer, List, ListItem, ListItemText } from "@mui/material";
import { config } from "./lib/envConfig";
import { get } from "./axiosUtils/appUtils";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import InputBase from "@mui/material/InputBase";

const App = () => {
  const { instance, accounts, inProgress } = useMsal();

  const adGroup = getADGroupName();

  const isAuthenticated =
    useIsAuthenticated() && adGroup.includes(localStorage.getItem("userGroup"));

  const userName = accounts.length > 0 ? accounts[0].username : "Guest";
  const navigate = useNavigate();
  const location = useLocation();
  const code = config?.VITE_FUNC_KEY_CODE;
  const [searchQuery, setSearchQuery] = useState("");
  const [sideTabs, setSideTabs] = useState(DIGITAL_ACCESS_MANAGEMENT_TABS);

  const routeTitles = {
    "/bulk-edit-fragrances": "Bulk Edit Fragrances",
    "/bulk-edit-associations": "Bulk Edit Associations",
    "/rename-fragrance-fields": "Rename Fragrance Fields",
    "/": "User Access Management",
  };

  const myRef = useRef(null);
  const title = routeTitles[location.pathname];

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (myRef.current) {
      myRef.current.setSearch(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === "Enter") {
      onSearchChange(e, searchQuery);
    }
  };

  const onSearchChange = (e, searchQuery) => {
    if (!myRef.current) return;
    if (
      (e?.key === "Enter" && searchQuery.length > 2) ||
      (e?.key === undefined && searchQuery === "")
    ) {
      myRef.current.fetchOnSearch(); 
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    if (myRef.current) {
      myRef.current.setSearch(""); 
    }

   
    setTimeout(() => {
      const fakeEvent = { key: undefined, target: { value: "" } };
      onSearchChange(fakeEvent, "");
    }, 0);
  };

  const getUserDetails = async () => {
    const url = `/getUserDetails?code=${code}&user_email=${userName}`;

    get(url)
      .then((response) => {
        if (adGroup.some(group => response.data.data.groupNames.includes(group))) {
            const responseAdGroup = response.data.data.groupNames;
            let isDigitalAccess = false;

           const isUAMAccess =  responseAdGroup.find(each => each.includes('UAM')) 
           if(isUAMAccess) {            
            localStorage.setItem("userGroup", responseAdGroup.find(group => group.includes('UAM')));            
            setSideTabs(USER_ACCESS_MANAGEMENT_TABS);
           }

           if(!isUAMAccess) {
            isDigitalAccess =  responseAdGroup.find(each => each.includes('Digital')) 
            localStorage.setItem("userGroup", responseAdGroup.find(group => group.includes('Digital')));
            setSideTabs(DIGITAL_ACCESS_MANAGEMENT_TABS);
            navigate("/bulk-edit-fragrances");
           }
        }
      })
      .catch((error) => {
        console.log("User details fetched failed", error);
      });
  };

  function getADGroupName() {
    if (config.VITE_API_URL.includes("dev")) {
      return [UAM_USER_ADMIN_AD_GROUP_DEV , UAM_USER_DIGITAL_AD_GROUP_DEV];
    } else if (config.VITE_API_URL.includes("qa")) {
      return [UAM_USER_ADMIN_AD_GROUP_QA, UAM_USER_DIGITAL_AD_GROUP_QA];
    } else {
      return [UAM_USER_ADMIN_AD_GROUP_PROD, UAM_USER_DIGITAL_AD_GROUP_PROD];
    }
  }

  useEffect(() => {
    if (accounts.length) {
      getUserDetails();
    }

    setTimeout(() => {
      if (!isAuthenticated && inProgress === InteractionStatus.None) {
        instance.loginRedirect();
      }
    }, 100);
  }, [isAuthenticated, inProgress, instance, accounts]);

  // TO DO
  const redirectTo = (text) => {
    setSearchQuery("");

    if (text === TAB_NAMES.AUDIT_LOGS) {
      navigate("/audit-logs");
    } else if (text === "Bulk Edit Fragrances") {
      navigate("/bulk-edit-fragrances");
    } else if (text === "Rename Fragrance Fields") {
      navigate("/rename-fragrance-fields");
    } else if (text === "Bulk Edit Associations") {
      navigate("/bulk-edit-associations");
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <AuthenticatedTemplate>
        <div className="App">
          <Box sx={{ flexGrow: 1 }}>
            <AppBar
              position="static"
              sx={{ backgroundColor: "rgb(225, 79%, 46%, 1;)" }}
            >
              <Toolbar>
                <img src={logoImage} alt="Logo" onClick={() => navigate("/")} />
                <Typography variant="h6" component="div" sx={{ marginLeft: 6 }}>
                  {title}
                </Typography>
                <Box sx={{ flexGrow: 1, marginLeft: "10vw" }}>
                  {(title === "Bulk Edit Associations" ||
                    title === "Bulk Edit Fragrances") && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "30vw",
                        backgroundColor: "white",
                        borderRadius: 1,
                        px: 2,
                      }}
                    >
                      <InputBase
                        placeholder="Search…"
                        inputProps={{ "aria-label": "search" }}
                        value={searchQuery}
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        fullWidth
                        sx={{
                          color: "black",
                          "& .MuiInputBase-input": {
                            padding: 1,
                          },
                        }}
                      />
                      <SearchIcon
                        sx={{ color: "black", mr: 1 }}
                        onClick={() => onSearchChange(null, searchQuery)}
                      />
                      <CloseIcon
                        sx={{ color: "black", mr: 1 }}
                        onClick={searchQuery ? handleClearSearch : undefined} // Disable click
                      />
                    </Box>
                  )}
                </Box>
                <Typography color="inherit" variant="body1">
                  {userName}
                </Typography>
              </Toolbar>
            </AppBar>
          </Box>
          <Box sx={{ display: "flex", padding: "15px 10px" }}>
            <Drawer
              variant="permanent"
              sx={{
                width: "13vw",
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                  width: "13vw",
                  boxSizing: "border-box",
                  height: "calc(100vh - 64px)",
                  top: "64px",
                },
              }}
            >
              <Box sx={{ overflow: "auto" }}>
                <List>
                  {sideTabs.map((text) => (
                    <ListItem
                      button
                      key={text}
                      onClick={() => redirectTo(text)}
                      sx={{
                        backgroundColor:
                          text === title ? "lightgray" : "transparent",
                      }}
                    >
                      <ListItemText primary={text} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
              <Routes ref={myRef} />
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div>{LOGIN_MESSAGE}</div>
      </UnauthenticatedTemplate>
    </>
  );
};

export default App;
